export default __webpack_public_path__ + "174653014c060260bfc521a26bfb305b.svg";